
      import UserCircle from './user-circle.vue'
      import type { App, Plugin } from 'vue'

      export const UserCirclePlugin: Plugin = {
        install(app: App) {
          app.component('UserCircle', UserCircle)
        },
      }
      export { UserCircle }
      